import { async } from "q";
import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetRenewalComparisonByClientId = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_RENEWAL_COMPARISON_BY_CLIENT_ID + Id,
    token
  );
  return res;
};

export const GetExperienceComparisonByClientId = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_EXPERIENCE_COMPARISON_BY_CLIENT_ID + Id,
    token
  );
  return res;
};

export const GetAsoComparisonByClientId = async (Id, UserId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ASO_COMPARISON_BY_CLIENT_ID + `${Id}&UserId=${UserId}`, token);
  return res;
};

export const GetRateReviewReports = async(id, type, UserId) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.GET_RATE_REVIEW_REPORT + `clientId=${id}&type=${type}&UserId=${UserId}`, "", token);
  return res;
};

// export const UpdateUnderwritingAdjustment =async (payload) => {
//   const token = localStorage.getItem("token");

//   return axios.put(
//     `${config.API_URL}/api/ACG_UnderWritingAdjustment/UpdateAdjustment`,
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
// };
